// Importez les locales dayjs nécessaires
import i18n from '@/i18n';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/zh';
import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import Stack from '@mui/material/Stack';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import dayjs, { Dayjs } from '@/dayjs';

import { setDateRangeFrom, setDateRangeTo, store } from '../store';

interface MonthRangePickerProps {
  direction?: 'row' | 'column';
  spacing?: number;
  inputWidth?: string;
}

function MonthRangePicker(props: MonthRangePickerProps) {
  const { direction, spacing, inputWidth } = props;
  const snap = useSnapshot(store);

  const handleDateFromChange = (value: Dayjs | null) => {
    if (value) {
      setDateRangeFrom(value);
    }
  };

  const handleDateToChange = (value: Dayjs | null) => {
    if (value) {
      setDateRangeTo(value);
    }
  };

  const currentLocale = i18n.language;
  console.log('currentLocale', currentLocale);
  const maxDate = dayjs().endOf('month');

  const { t } = useTranslation();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={currentLocale}
    >
      <Stack
        direction={direction || 'row'}
        alignItems="center"
        justifyContent="center"
        spacing={spacing || 1}
        sx={{ width: '100%' }}
      >
        <DatePicker
          label={t('filters.from')}
          views={['month', 'year']}
          openTo="month"
          format="MMM YYYY"
          disableFuture
          sx={{ width: inputWidth || '50%' }}
          value={snap.daterange.from}
          onChange={handleDateFromChange}
          minDate={snap.globals.minDate}
          maxDate={snap.daterange.to || undefined}
        />
        <DatePicker
          label={t('filters.to')}
          views={['month', 'year']}
          openTo="month"
          format="MMM YYYY"
          sx={{
            width: inputWidth || '50%',
          }}
          minDate={snap.globals.minDate}
          maxDate={maxDate}
          value={snap.daterange.to}
          onChange={handleDateToChange}
        />
      </Stack>
    </LocalizationProvider>
  );
}

export { MonthRangePicker };
